import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// ── API auth: attach X-Vesper-Key to every backend request ──────────────────
// Backend requires this header when VESPER_API_KEY is set on Railway.
// Key comes from the Vercel env (VITE_VESPER_API_KEY) or localStorage
// ('vesper_api_key' — settable from the browser console as a fallback).
// Patching fetch once here covers every call in the whole app.
{
  const VESPER_KEY = import.meta.env.VITE_VESPER_API_KEY
    || (typeof localStorage !== 'undefined' && localStorage.getItem('vesper_api_key'))
    || '';
  if (VESPER_KEY && typeof window !== 'undefined') {
    const BACKEND_ORIGIN = (() => {
      try { return new URL(import.meta.env.VITE_BACKEND_URL || 'https://vesper-backend-production-b486.up.railway.app').origin; }
      catch { return ''; }
    })();
    const _origFetch = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const isBackend = url.startsWith('/api/')
          || (BACKEND_ORIGIN && url.startsWith(BACKEND_ORIGIN))
          || /railway\.app\/api\//.test(url);
        if (isBackend) {
          init.headers = { ...(init.headers || {}), 'X-Vesper-Key': VESPER_KEY };
        }
      } catch { /* never break a request over auth decoration */ }
      return _origFetch(input, init);
    };
  }
}

// Register service worker for PWA install + push notifications.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('[Vesper SW] Registered, scope:', registration.scope)

        // Request notification permission so Vesper can push alerts to CC
        if ('Notification' in window && Notification.permission === 'default') {
          // Small delay so it doesn't fire before the UI renders
          setTimeout(() => {
            Notification.requestPermission().then((permission) => {
              console.log('[Vesper SW] Notification permission:', permission)
            })
          }, 3000)
        }
      })
      .catch((err) => {
        console.warn('[Vesper SW] Registration failed:', err)
      })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
